import { ToggleStateStore } from 'stores/common';
import { ILocalStore } from 'stores/interfaces';
import { EntryRangeDate } from 'stores/models';

import { IVerificationFormStore } from '../interface';

type PublishModalParams = {
  verificationStore: IVerificationFormStore;
};

class PublishModal implements ILocalStore {
  constructor({ verificationStore }: PublishModalParams) {
    this._verificationStore = verificationStore;
  }

  readonly modalState = new ToggleStateStore();

  private readonly _verificationStore: IVerificationFormStore;

  readonly entryRange = new EntryRangeDate();

  destroy() {
    this.modalState.destroy();
    this.entryRange.destroy();
  }
}

export default PublishModal;
